import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { authSlice } from '»components/Auth';
import { menusSlice } from '»components/Menus';
import { questionnaireSlice } from '»components/Questionnaire/redux';

export function usePageNavigation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return {
    navigateToPage: ({
      route,
      menuItem,
      state,
      shouldResetAuth,
      shouldResetQuest,
    }) => {
      navigate(
        route,
        state && {
          state,
        },
      );
      dispatch(
        menusSlice.actions.setActiveMenuItem({
          activeMenuItem: menuItem,
        }),
      );

      if (shouldResetAuth) dispatch(authSlice.actions.resetAuth());
      if (shouldResetQuest)
        dispatch(questionnaireSlice.actions.clearQuestionnaire());
    },
  };
}
